/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Coinvestments_Reasonforinclusion3Inputs */

const en_coinvestments_reasonforinclusion3 = /** @type {(inputs: Coinvestments_Reasonforinclusion3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Reason for Inclusion`)
};

/**
* | output |
* | --- |
* | "Reason for Inclusion" |
*
* @param {Coinvestments_Reasonforinclusion3Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const coinvestments_reasonforinclusion3 = /** @type {((inputs?: Coinvestments_Reasonforinclusion3Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Coinvestments_Reasonforinclusion3Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_coinvestments_reasonforinclusion3(inputs)
});
export { coinvestments_reasonforinclusion3 as "coInvestments_reasonForInclusion" }